import css from 'styled-jsx/css';

const styles = css.global`#meu-financiamento-debito {
    background: #222;
    padding: 64px 0 93px;
}

.is-desk {
    display: none;
}

#meu-financiamento-debito .debito-titulo {
    color: #FFF;
    font-family: "SantanderHeadline";
    font-size: 48px;
    font-style: normal;
    font-weight: 400;
    line-height: 60px;
    margin: 0;
}

#meu-financiamento-debito .debito-paragrafo {
    color: #FFF;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    margin: 24px 0 32px;
}

#meu-financiamento-debito .debito-paragrafo b {
    font-weight: 600;
}

#meu-financiamento-debito .slide {
    border-radius: 4px;
    background: #444;
    display: flex;
    max-width: 252px;
    height: 360px;
    padding: 32px 24px 64px 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
    margin-right: 16px;
}

#meu-financiamento-debito .slide .text {
    color: #FFF;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#meu-financiamento-debito .home-pagination {
    margin-top: 16px;
    justify-content: center;
}

#meu-financiamento-debito .debito-paragrafo span {
    color: #999;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    margin-bottom: 48px;
    margin-top: 24px;
}

#meu-financiamento-debito .debito-content-text {
    margin-top: 64px;
}

#meu-financiamento-debito .box-branco {
    border-radius: 4px;
    border: 1px solid #C00;
    background: #DEEDF2;
    display: flex;
    width: 200px;
    height: 121px;
    padding: 24px 16px;
    align-items: flex-start;
    flex-direction: column;
}

#meu-financiamento-debito .box-titulo {
    color: #444;
    font-family: "SantanderText";
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    margin-top: 8px;
}

#meu-financiamento-debito .box-negrito {
    color: #C00;
    font-family: "SantanderText";
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
}

#meu-financiamento-debito .box-subtitulo {
    color: #767676;
    font-family: "SantanderText";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
}

#meu-financiamento-debito .debito-parcelas {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 48px;
}

#meu-financiamento-debito .debito-btn-red {
    width: 100%;
    max-width: 272px;
    height: 48px;
    margin: 40px auto 0;
}

#meu-financiamento-debito .debito-seta {
    margin: 32px 0 16px;
}

@media(min-width: 992px) {
    #meu-financiamento-debito .is-desk {
        display: flex;
        gap: 40px;
    }

    #meu-financiamento-debito .is-mob {
        display: none;
    }

    #meu-financiamento-debito .slide {
        max-width: 620px;
        height: 320px;
        margin-top: 24px;
        margin-right: 0;
        width: 100%;
    }

    #meu-financiamento-debito .debito-titulo {
        font-size: 72px;
        max-width: 900px;
        line-height: 120%;
    }

    #meu-financiamento-debito {
        padding: 93px 0;
    }

    #meu-financiamento-debito .debito-content-text {
        margin-top: 72px;
    }

    #meu-financiamento-debito .debito-content-text .debito-titulo {
        font-size: 40px;
        font-style: normal;
        font-weight: 400;
        line-height: 60px;
    }

   

    #meu-financiamento-debito .debito-seta {
        margin: 0 56px 0 32px;
        transform: rotate(270deg);
    }

    #meu-financiamento-debito .box-branco {
        min-width: 203px;
    }

    #meu-financiamento-debito .debito-btn-red {
        margin: 88px auto 0;
        max-width: 272px;
    }
}

@media(min-width: 1270px) {
    #meu-financiamento-debito .debito-parcelas {
        flex-direction: row;
    }
}

@media(min-width: 1280px) {
    #meu-financiamento-debito .ctn-home-24 {
        max-width: 1280px;
    }
}`;

export default styles;